<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Good Psychologist</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="para"> </p>
<h2 class="h2">TABLE OF CONTENTS</h2>
<p class="para"> </p>
<p class="para"> </p>
<p class="toc-entry"><span href="#/xhtml/title" title="Link target outside of Sample">TITLE</span></p>
<p class="toc-entry"><a href="#/xhtml/copyright">COPYRIGHT</a></p>
<p class="toc-entry"><a href="#/xhtml/dedication">DEDICATION</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter01">THE GOOD PSYCHOLOGIST</a></p>
<p class="toc-entry"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6953888d